var _ellipse, _path, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 16.9791,
    rx: 17,
    ry: 16.9791,
    fill: "#006DB7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3145 16.162C24.1292 14.5048 23.3852 12.9599 22.2047 11.7809C21.0242 10.6018 19.4774 9.85871 17.8182 9.67361V8.80741C17.8182 8.35796 17.45 7.99023 17 7.99023C16.55 7.99023 16.1818 8.35796 16.1818 8.80741V9.67361C14.5226 9.85871 12.9758 10.6018 11.7953 11.7809C10.6148 12.9599 9.87078 14.5048 9.68545 16.162H8.81818C8.36818 16.162 8 16.5297 8 16.9792C8 17.4286 8.36818 17.7963 8.81818 17.7963H9.68545C9.87078 19.4535 10.6148 20.9984 11.7953 22.1774C12.9758 23.3565 14.5226 24.0996 16.1818 24.2847V25.1509C16.1818 25.6003 16.55 25.9681 17 25.9681C17.45 25.9681 17.8182 25.6003 17.8182 25.1509V24.2847C19.4774 24.0996 21.0242 23.3565 22.2047 22.1774C23.3852 20.9984 24.1292 19.4535 24.3145 17.7963H25.1818C25.6318 17.7963 26 17.4286 26 16.9792C26 16.5297 25.6318 16.162 25.1818 16.162H24.3145ZM17 22.6994C13.8336 22.6994 11.2727 20.1416 11.2727 16.9792C11.2727 13.8167 13.8336 11.2589 17 11.2589C20.1664 11.2589 22.7273 13.8167 22.7273 16.9792C22.7273 20.1416 20.1664 22.6994 17 22.6994Z",
    fill: "#C6E8FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.0003,
    cy: 16.9796,
    rx: 3.27273,
    ry: 3.2687,
    fill: "#C6E8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocationIcon);
export default __webpack_public_path__ + "static/media/current-location-icon.6100dfc7d6d3414ba44ab312b68fdbf5.svg";
export { ForwardRef as ReactComponent };